import React from "react";
import {
	AntdButton,
	CarCard,
	DetailCard,
	Inner,
	KeyCarContainer,
	Section,
} from "./styles.js";
import { Typo } from "../../../../../../components/layout/theme/index.js";
import { useReport } from "../../../../../../contexts/ReportContext.js";
import { useFilter } from "../../../../../../contexts/FilterContext.js";
import { useMatomo } from "@datapunt/matomo-tracker-react";

const CarData = ({ nextSubStep }) => {
	const { updateReportForm, reportForm } = useReport();
	const { carData } = useFilter();
	const { trackEvent } = useMatomo();

	const handleNextStep = () => {
		const formValues = {
			patent: carData?.patent,
			brandName: carData?.brandName,
			modelName: carData?.modelName,
			description: carData?.description,
			year: carData?.year,
			codia: carData?.codia,
			brandId: carData?.brandId,
			modelId: carData?.modelId,
			position: carData?.position,
			titularActual: reportForm?.titularActual || null,
			automotor: reportForm?.automotor || null,
		};
		updateReportForm(formValues, 1);
		nextSubStep(2);
	};

	return (
		<Inner>
			<Typo level={2}>¿Este es el auto?</Typo>
			<CarCard>
				<KeyCarContainer>{carData?.patent}</KeyCarContainer>
				<Typo level={303}>
					{carData?.brandName} {carData?.modelName}
				</Typo>
				<DetailCard>
					<Section>
						<Typo level={305}>Modelo</Typo>
						<Typo level={305}>{carData?.description || carData?.modelName}</Typo>
					</Section>
					<Section>
						<Typo level={305}>Año</Typo>
						<Typo level={305}>{carData?.year}</Typo>
					</Section>
				</DetailCard>
				<Section>
					<AntdButton key="PrevStep1CarData" onClick={() => nextSubStep(0)}>
						<Typo level={5}>No, modificar</Typo>
					</AntdButton>
					<AntdButton
						key="NextStep1CarData"
						type="primary"
						onClick={handleNextStep}
					>
						<Typo level={5} type="white">
							Si, continuar
						</Typo>
					</AntdButton>
				</Section>
			</CarCard>
		</Inner>
	);
};

export default CarData;
